import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polyline
    {...props}
    points="16.33 37.92 25.02 48 52.53 48.57 52.53 27.47 30.75 10.32"
  />
);

export const AvatarArtworkChani = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.chani}
    renderShadow={renderShadow}
  >
    <g
      style={{
        transform: 'scale(1.1) translate(-2px, -2px)',
      }}
    >
      <path
        d="M12.5,31.35c.16.89.32,1.79.71,2.61.79,1.7,2.46,2.85,4.24,3.45s3.67.7,5.54.81c.7.04,1.41.08,2.1-.04.6-.11,1.17-.33,1.74-.55,1.01-.4,2.02-.79,3.03-1.19.59-.23,1.19-.47,1.72-.83.6-.41,1.08-.98,1.52-1.57,1.87-2.49,3.12-5.57,2.87-8.67-.15-1.87-.84-3.66-1.05-5.52-.11-.95-.1-1.95-.49-2.83-.58-1.33-1.92-2.14-3.22-2.78-.87-.43-1.77-.84-2.7-1.11-2-.58-4.13-.53-6.21-.48-.67.02-1.34.03-1.97.25-.6.21-1.12.58-1.6.98-1.18.95-2.12.41-3.35,1.28-1.38.98-3.91,10.32-3.67,11.66.27,1.51.54,3.02.82,4.53Z"
        fill="#423926"
      />
      <path
        d="M36.4,31.15c-.68.95-1.46,1.86-2.22,2.75-.85.96-1.3,2.15-2.46,2.73-.7.36-.87.44-1.59.79-.68.32-.57.79-1.26,1.08-1.19.54-4.3.51-5.6.56-2.17.07-6.5.08-6.94-1.15-.14-.38.68-.46-.12-.67-.66-.17-1.04-.55-1.6-.92-.97-.64-1.6-1.68-1.98-2.76-.39-1.08-.55-2.24-.79-3.36-.07-.35-.56-.45-.64-.8.46.21.92.42,1.36.68.64.37,1.2.81,1.65,1.4.03.04,1.24,1.45,2.25,1.95.67.34,4.25,2.12,4.98,2.29,1.55.36,4.83.13,5.89-.52.72-.44,4.11-1.19,5.65-2.81.76-.89,1.4-1.07,2.61-2.2.27-.26.28,1.06.82.96Z"
        fill="#d1b782"
      />
      <path
        d="M17.61,35.15c.33.11.67.19,1,.28.81.24,1.55.59,2.34.87,2.4.83,5.56,1.22,11.8-2.16-.24.37-4.92,3.06-5.43,3.14-1.58.25-3.17.46-4.76.67-.55.07-.94-.02-1.5-.01-.58,0-1.72-.4-2.28-.54,1.43-.38,3.5.69,4.87.19-1.34-.4-1.53-.67-2.38-.81s-1.73-.22-2.55-.47c-1.08-.33-2-.93-3.06-1.29-.71-.24-1.42-.69-1.86-1.39.81.88,3.13,1.3,3.82,1.52Z"
        fill="#c4ac7a"
      />
      <path
        d="M32.76,31.5c-1.49,2.51-7.34,5.77-9.05,5.77-1.44,0-7.07-3.22-8.45-5.77-.45-.83-.9-8.77-.9-8.77l.04-.02c-.03-.32-.04-.64-.04-.97,0-6.1,4.32-11.04,9.65-11.04s9.65,4.94,9.65,11.04c0,.33-.01.65-.04.97l.04.02s-.32,7.78-.9,8.77Z"
        fill="#c98f5c"
      />
      <path
        d="M25.17,29.59c-.3.03-.88.15-1.18.15s-.86-.12-1.15-.15c-.54-.05-.99-.28-.99-.62h0c0-.34.45-.67.99-.62.29.02.86.15,1.15.15s.88-.12,1.18-.15c.54-.05.99.28.99.62h0c0,.34-.45.57-.99.62Z"
        fill="#2b2418"
      />
      <path
        d="M26.61,33.22h-5.3c-.16,0-.17-.39,0-.58.46-.52,1.25-.8,1.91-1.07.3-.02.59.09.89.11.42,0,.48-.26,1.04,0,.56.26.97.48,1.47.88.23.18.26.66,0,.66Z"
        fill="#b35736"
      />
      <path
        d="M26.74,33.29c-.3.36-1.81.59-2.84.59-.69,0-2.71-.4-2.71-.72,0-.13.16-.25.25-.27,1.23-.35,3.46-.2,5.16,0,.25.03.26.28.14.4Z"
        fill="#c96d4c"
      />
      <path
        d="M33.93,24.68c-1.11.14-.57-2.45-1.66-2.76-.69-.19-.99.21-1.57-.22-.86-.64-.19-2.45-.94-3.23-.52-.54-1.61-.82-3.01-.5-.72.16-1.56-.14-1.99-.76-.28-.41-.32-.94-.35-1.44-.08-1.37-.15-3.03-.23-4.11,2.28-.79,4.57-.62,8.02,3.04,3.22,3.4,1.72,9.99,1.72,9.99Z"
        fill="#4d230f"
        stroke="#401c0a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.72,24.68c.7-.78,1.22-3.65,1.79-4.55.4-.63.82-1.34,1.48-1.58.4-.15.83-.11,1.25-.08,1.67.1,2.61.62,4.11-.21.08-.05,1.92-1.03,1.92-1.03,0,0-.08-4.14-.27-5.59-1.4-1.06-4.75-.07-7.24,2.34-3.66,3.56-3.05,10.7-3.05,10.7Z"
        fill="#4d230f"
        stroke="#401c0a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.96,23.22c1.93.23,2.94,1.24,4.07,2.32,2.04,1.94,3.95,3.55,6.98,3.5"
        fill="none"
        stroke="#2b2418"
        strokeMiterlimit="10"
        strokeWidth="0.5"
      />
      <path
        d="M21.29,17.2c-.76.52-1.33,1.31-1.67,2.19-.2.52-.33,1.08-.59,1.57s-.7.93-1.24.99c.22.3.66.34.98.18s.55-.48.73-.8c.24-.45.42-.94.57-1.42.12-.37.24-.76.48-1.06.44-.53,1.16-.66,1.81-.83.45-.12,1.88-.67,1.19-1.35-.48-.48-1.83.25-2.26.54Z"
        fill="#4d230f"
        stroke="#401c0a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.29,23.74c.47-1.8.95-3.6,1.42-5.4.24-.93.49-1.86.88-2.74,1.12-2.54,3.38-4.46,5.88-5.68,1.14-.55,2.34-.98,3.6-1.12,1.55-.18,3.12.08,4.65.39,1.06.21,2.16.47,3.02,1.13.84.64,1.37,1.6,1.88,2.54.43.79.86,1.58,1.29,2.37.52.95,1.04,1.91,1.43,2.91.68,1.73,1,3.59,1.3,5.42.25,1.52.51,3.04.76,4.56.17.99.32,2.07-.15,2.96-.49.93-3.86,2.77-4.92,3.02-.44.1,1.49-1.22,1.06-1.16,1.73-2.26,2.14-5.31,1.7-8.11s-1.66-5.42-2.96-7.95c-.63-1.23-1.33-2.49-2.47-3.26-1.16-.77-2.61-.92-3.99-1.03-3-.23-6.16-.3-8.85,1.03-.29.14-.57.3-.81.52-.29.28-.49.63-.68.99-1.71,3.34-2.31,7.12-2.71,10.85-.09.86-.17,1.74.02,2.59.34,1.45,1.68,2.72,1.71,4.22-1.74.03-2.75-1.43-3.36-2.91-.8-1.97-.25-4.19.27-6.16Z"
        fill="#d1b782"
      />
      <path
        d="M13.13,21.27c-.07-2.99,1.29-5.91,3.31-8.12.2-.22.4-.43.65-.59.32-.21.68-.32,1.05-.43,2.26-.66,4.59-1.07,6.94-1.22.96-.06,1.94-.08,2.88.16.88.22,1.68.67,2.48,1.1.24.13.48.27.68.45.19.17.34.39.49.6.18.26.36.52.54.78.26.38.53.76.77,1.16,1.35,2.15,2.16,4.63,2.35,7.15-.45-1.04-.91-2.09-1.36-3.13-.7-1.62-1.42-3.26-2.51-4.65-.41-.52-.88-1.02-1.47-1.34-.69-.39-1.48-.52-2.27-.61-2.88-.35-5.85-.25-8.62.6-.43.13-.85.28-1.22.54-.43.3-.76.72-1.05,1.16-.48.74-.86,1.54-1.25,2.34-.74,1.55-1.92,3.99-2.66,5.54"
        fill="#d1b782"
      />
      <path
        d="M35.24,26.17c-.41,1.77-.58,3.09-1.13,2.95s-1.39-2.24-.97-4.01,1.31-2.52,1.86-2.39.66,1.67.25,3.44Z"
        fill="#c98f5c"
      />
      <path
        d="M12.8,25.92c.41,1.77.58,3.09,1.14,2.95s1.42-2.25,1.01-4.02-1.32-2.52-1.88-2.38-.68,1.68-.26,3.45Z"
        fill="#c98f5c"
      />
    </g>
  </AvatarArtwork>
);

export default AvatarArtworkChani;
